import {
  createRouter,
  createWebHashHistory,
  // createWebHistory

} from 'vue-router';
import {
  showConfirmDialog
} from "vant"
const routerHashHistory = createWebHashHistory()
// const routerHistory = createWebHistory()

import routes from './list.js'
const router = createRouter({
  history: routerHashHistory,
  // history: routerHistory,

  routes
})

router.beforeEach(
  (to, from, next) => {
    if (to.meta.title == '意见反馈') {
      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
            title: '是否登录'
          })
          .then(() => {
            // on confirm
            sessionStorage.setItem('backPath', from.path),
              next('/login')
          }).catch(() => {
            return false
          });

      } else {
        next()
      }
    } else {
      next()
    }

  }



  // const path = route.matched[0].path
  // if( path == '/feedback' || path == '/shop/feedback') {
  //     showConfirmDialog({
  //         title: '是否登录'
  //       })
  //       .then(() => {
  //         // on confirm
  //         router.push({path:"/login"})
  //       })
  //       return false

  // }
)
export default router